import { NoResultsFound } from "@components/NoResultsFound";
import { EMPTY_QUERY, ThreadQuery, ThreadTab } from "./types";
import { IconMessage } from "@components/IconMessage";
import { useUserConfiguration } from "@hooks/useUserConfiguration";

export function NoResults({ tab, filters }: { tab: ThreadTab; filters: ThreadQuery }) {
  function noActiveFiltersForTab(tab: ThreadTab) {
    return (Object.keys(EMPTY_QUERY) as (keyof ThreadQuery)[]).every((key) => {
      if (
        (tab === "assigned_to_me" && key === "staff_assignee") ||
        (tab === "assigned_to_my_team" && key === "assignee")
      ) {
        return true;
      }
      if (Array.isArray(filters[key])) {
        // update this if the EMPTY_QUERY ever changes to have non-empty arrays
        return filters[key].length === 0;
      }
      return filters[key] === EMPTY_QUERY[key];
    });
  }

  const { currentUser } = useUserConfiguration();
  const hasMultipleTeams = currentUser.support_teams && currentUser.support_teams.length > 1;

  // If there are truly no results in an assignment tab -- that is, more than just no results due to filters/search --
  // we show a special message.
  if (tab === "assigned_to_me" || tab === "assigned_to_my_team") {
    if (noActiveFiltersForTab(tab)) {
      const caption =
        tab === "assigned_to_me"
          ? "0 messages assigned to you."
          : `0 messages assigned to your ${hasMultipleTeams ? "teams" : "team"}.`;
      return (
        <div className="margin--top--xxl">
          <IconMessage icon="message-square" caption={caption} />
        </div>
      );
    }
  }

  return <NoResultsFound />;
}
